import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { useMe } from '@entities/user/api';
import { useAuthDialog } from '@features/auth';
import { ROUTES } from '@shared/config/routes';
import { useStuck } from '@shared/lib/useStuck';
import { Button, Container, Logo } from '@shared/ui';

import { AccountMenu } from './AccountMenu';
import styles from './Header.module.css';
import { LanguageMenu } from './LanguageMenu';

/**
 * Публичная шапка (DESIGN_SYSTEM §4.3, редизайн 2026-10): тёмная панель,
 * слева логотип, справа выбор языка и «Anmelden» — у вошедшего вместо кнопки
 * меню аккаунта.
 *
 * Навигации, кнопки «Auto finden» и гамбургера нет ни на одной ширине —
 * решение заказчика по макетам 2026-10. «So funktioniert's», «Über CarViQ.DE»
 * и «Meine Bestellungen» остались в подвале. Гамбургер прятал бы на телефоне пункты,
 * которых у шапки больше нет, поэтому все три элемента стоят в одной строке
 * и на 370 px.
 */
export function Header() {
  const { t } = useTranslation();
  const { requestAuth } = useAuthDialog();
  const { data: session } = useMe();
  // Сторож стоит на 80 px ниже верха страницы: как только он уходит из вьюпорта,
  // шапка получает нижнюю границу. Слушатель scroll для этого не нужен.
  const { sentinelRef, stuck } = useStuck<HTMLDivElement>();

  return (
    <>
      <div ref={sentinelRef} className={styles.sentinel} aria-hidden="true" />
      <header className={[styles.header, stuck && styles.scrolled].filter(Boolean).join(' ')}>
        <Container className={styles.inner}>
          <Link to={ROUTES.home} className={styles.brand} aria-label={t('brand.name')}>
            <Logo inverse />
          </Link>

          <div className={styles.actions}>
            <LanguageMenu />
            {session ? (
              <AccountMenu user={session.user} inverse />
            ) : (
              <Button
                variant="inverse"
                className={styles.login}
                onClick={() => {
                  // Модальное окно, а не переход на /login: пользователь не
                  // теряет страницу, на которой находится (MVP_PRD §8).
                  requestAuth();
                }}
              >
                {t('nav.login')}
              </Button>
            )}
          </div>
        </Container>
      </header>
    </>
  );
}
